import * as yup from "yup";
import { parse, isAfter, isEqual, startOfDay } from "date-fns";

const createPsrFormSchema = (isNewPSR = false) => {
  let psrRequiredByDtField = yup
    .string()
    .trim()
    .required("Required By Date is required.");

  // Only apply future date validation for new PSR
  if (isNewPSR) {
    psrRequiredByDtField = psrRequiredByDtField.test(
      "is-today-or-future",
      "Date must be today or in the future",
      (value) => {
        if (!value) return true; // Let required() handle empty values
        try {
          const inputDate = parse(value, "dd-MMM-yyyy", new Date());
          const today = startOfDay(new Date());
          return isAfter(inputDate, today) || isEqual(inputDate, today);
        } catch (error) {
          return false;
        }
      }
    );
  }

  return yup.object({
    psrName: yup
      .string()
      .trim()
      .required("Name is required.")
      .max(100, "Cannot exceed 100 characters."),
    psrVersionDt: yup.string().trim().required("For Version Date is required."),
    psrType: yup.string().trim().required("PSR Type is required."),
    psrRequiredByDt: psrRequiredByDtField,
    isEvaluationByGroup: yup
      .boolean()
      .transform((value) => {
        if (value === "" || value === null) {
          return undefined;
        }
        return value;
      })
      .required("Evaluation by Group is required."),
    requestedStatus: yup.string().trim().required("Status is required."),

    sourceSubmittedBy: yup.string().trim().required("Source is required."),
    ctsuProcessingInstructions: yup
      .string()
      .trim()
      .max(4000, "Cannot exceed 4000 characters.")
      .required("CTSU Processing Instructions is required."),
    psrComments: yup
      .string()
      .trim()
      .max(500, "Cannot exceed 500 characters.")
      .nullable(),

    psrContactName: yup
      .string()
      .trim()
      .max(100, "Cannot exceed 100 characters.")
      .required("Name is required."),
    psrContactPhoneNum: yup
      .string()
      .trim()
      .max(100, "Cannot exceed 100 characters.")
      .required("Phone is required."),
    psrContactEmailAddress: yup
      .string()
      .trim()
      .max(100, "Cannot exceed 100 characters.")
      .required("Email is required."),
    psrDistributionList: yup
      .string()
      .trim()
      .max(500, "Cannot exceed 500 characters.")
      .nullable(),

    createdBy: yup.string().nullable(),
    createdDate: yup.string().nullable(),
    modifiedBy: yup.string().nullable(),
    modifiedDate: yup.string().nullable()
  });
};

// Default schema for backward compatibility (existing PSR)
const PsrFormSchema = createPsrFormSchema(false);

export { PsrFormSchema, createPsrFormSchema };
